import { Trash2, X, CheckSquare } from "lucide-react";

/**
 * Floating bar that appears when items are selected on a list page.
 * Renders nothing when count === 0.
 */
export function BulkBar({ count, entityLabel = "items", onClear, onDelete, busy }) {
  if (!count) return null;
  return (
    <div
      data-testid="bulk-bar"
      className="fixed bottom-6 left-1/2 z-40 -translate-x-1/2 rounded-full border border-border/70 bg-card/95 px-4 py-2 shadow-lg shadow-black/10 backdrop-blur"
    >
      <div className="flex items-center gap-3">
        <span className="inline-flex items-center gap-2 text-xs font-medium">
          <CheckSquare className="h-3.5 w-3.5 text-primary" />
          <span data-testid="bulk-bar-count">{count}</span> {entityLabel} selected
        </span>
        <div className="h-4 w-px bg-border" />
        <button
          data-testid="bulk-bar-delete"
          onClick={onDelete}
          disabled={busy}
          className="inline-flex items-center gap-1.5 rounded-md bg-destructive/10 px-2.5 py-1 text-xs font-semibold text-destructive hover:bg-destructive/20 disabled:opacity-60"
        >
          <Trash2 className="h-3.5 w-3.5" />
          {busy ? "Deleting…" : "Delete"}
        </button>
        <button
          data-testid="bulk-bar-clear"
          onClick={onClear}
          className="inline-flex items-center gap-1 rounded-md border border-border/70 px-2 py-1 text-xs text-muted-foreground hover:bg-secondary"
        >
          <X className="h-3.5 w-3.5" />
          Clear
        </button>
      </div>
    </div>
  );
}

/**
 * Small controlled checkbox — pure Tailwind, no shadcn dep.
 */
export function RowCheckbox({ checked, onChange, testid, indeterminate = false }) {
  return (
    <input
      ref={(el) => { if (el) el.indeterminate = indeterminate; }}
      type="checkbox"
      data-testid={testid}
      checked={checked}
      onChange={onChange}
      onClick={(e) => e.stopPropagation()}
      className="h-4 w-4 cursor-pointer rounded border-border/70 accent-primary"
    />
  );
}

/**
 * Bulk delete helper — deletes items in parallel, returns count of successes.
 */
export async function bulkDelete(ids, deleteOne) {
  const results = await Promise.allSettled(ids.map((id) => deleteOne(id)));
  return results.filter((r) => r.status === "fulfilled").length;
}
